__turbopack_context__.v({
  "background-graphics": "pT_1RG_background-graphics",
  "content": "pT_1RG_content",
  "hero-section-content-wrapper": "pT_1RG_hero-section-content-wrapper",
});
